"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/core/SearchPage/index.vue"));
var _feedback = require("@/api/feedback");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Feedback',
  components: {
    SearchPage: _index.default
  },
  data: function data() {
    return {
      loading: false,
      typeOptions: [{
        label: '产品建议',
        value: 0,
        tag: 'blue'
      }, {
        label: '交易投诉',
        value: 1,
        tag: 'red'
      }]
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '用户ID',
        prop: 'uid',
        defaultValue: '',
        type: 'input'
      }, {
        label: '二级分类',
        prop: 'category',
        defaultValue: '',
        type: 'input'
      }, {
        label: '创建时间',
        prop: 'createTime',
        defaultValue: [],
        type: 'datetimeRange',
        options: {
          startKey: 'startTime',
          endKey: 'endTime',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 80
      }, {
        key: 'uid',
        visible: true,
        label: "\u7528\u6237ID",
        width: 80
      }, {
        key: 'type',
        visible: true,
        label: "\u95EE\u9898\u5206\u7C7B",
        width: 80,
        formatter: 'tag'
      }, {
        key: 'category',
        visible: true,
        label: "\u4E8C\u7EA7\u5206\u7C7B",
        width: 120
      }, {
        key: 'description',
        visible: true,
        label: "\u8BE6\u7EC6\u63CF\u8FF0",
        width: 180
      }, {
        key: 'imageUrls',
        visible: true,
        label: "\u56FE\u7247",
        width: 180
      }, {
        key: 'contact',
        visible: true,
        label: "\u8054\u7CFB\u65B9\u5F0F",
        width: 140
      }, {
        key: 'createTime',
        visible: true,
        label: "\u521B\u5EFA\u65F6\u95F4",
        width: 160
      }];
    }
  },
  created: function created() {},
  methods: {
    getList: function getList(params) {
      return (0, _feedback.getFeedbackList)(params).then(function (res) {
        var list = (res.list || []).map(function (item) {
          item.imageUrls = item.imageUrls.split(',').filter(function (v) {
            return v;
          });
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'type') {
        var target = this.typeOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    markHandle: function markHandle(row) {
      var _this = this;
      this.$modalSure('确认已处理？').then(function () {
        var params = {
          id: row.id
        };
        _this.loading = true;
        (0, _feedback.handleFeedbackApi)(params).then(function (res) {
          _this.loading = false;
          _this.$message.success('处理成功');
          _this.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this.loading = false;
        });
      });
    }
  }
};